'use client'

import { motion } from 'framer-motion'
import { Join } from 'design-studio/lib'

interface FeatureCardProps {
  title: string
  description: string
  icon?: React.ReactNode
  /** Tailwind class for the small dot indicator, e.g. "bg-teal-400" */
  dot?: string
  /** Tailwind classes for the border accent, e.g. "border-teal-500/30 hover:border-teal-400/50" */
  accent?: string
  delay?: number
  className?: string
}

export function FeatureCard({
  title,
  description,
  icon,
  dot,
  accent,
  delay = 0,
  className,
}: FeatureCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
      className={Join(
        'rounded-xl border bg-slate-900/40 p-6 backdrop-blur-md transition-all duration-200 hover:bg-slate-900/50',
        accent ?? 'border-slate-700/60 hover:border-cyan-500/30',
        className,
      )}
    >
      {(icon || dot) && (
        <div className="mb-3 flex items-center gap-2">
          {dot && <span className={Join('h-2 w-2 rounded-full', dot)} />}
          {icon}
        </div>
      )}
      <h3 className="font-display text-2xl font-light tracking-tight text-white">
        {title}
      </h3>
      <p className="font-display mt-2 text-base leading-normal font-light tracking-normal text-slate-300/80">
        {description}
      </p>
    </motion.div>
  )
}
